import React, { useState } from "react";
import { Stack, Chip, Popover, IconButton } from "@mui/material";

const EMOJI_LIST = ["👍", "❤️", "😂", "😮", "😢", "🔥", "👀", "✅"];

const CommentReactions = ({ reactions = [], currentUserId, onToggle }) => {
  const [anchor, setAnchor] = useState(null);

  const grouped = reactions.reduce((acc, r) => {
    if (!acc[r.emoji]) acc[r.emoji] = { emoji: r.emoji, count: 0, users: [] };
    acc[r.emoji].count += 1;
    acc[r.emoji].users.push(r.userId || r.user?.id);
    return acc;
  }, {});

  const entries = Object.values(grouped);

  return (
    <Stack direction="row" gap="4px" alignItems="center" flexWrap="wrap">
      {entries.map((g) => {
        const isMine = g.users.includes(currentUserId);
        return (
          <Chip
            key={g.emoji}
            label={`${g.emoji} ${g.count}`}
            size="small"
            variant={isMine ? "filled" : "outlined"}
            onClick={() => onToggle(g.emoji)}
            sx={{
              fontSize: 11,
              height: 22,
              cursor: "pointer",
              ...(isMine
                ? { backgroundColor: "hubColors.mainFocusLighter2" }
                : {}),
            }}
          />
        );
      })}
      <Chip
        label="+"
        size="small"
        variant="outlined"
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ fontSize: 11, height: 22, cursor: "pointer", minWidth: 28 }}
      />
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Stack direction="row" gap="2px" p="6px">
          {EMOJI_LIST.map((emoji) => (
            <IconButton
              key={emoji}
              size="small"
              onClick={() => {
                onToggle(emoji);
                setAnchor(null);
              }}
              sx={{ fontSize: 16, width: 30, height: 30 }}
            >
              {emoji}
            </IconButton>
          ))}
        </Stack>
      </Popover>
    </Stack>
  );
};

export default CommentReactions;
